import heroImg from "@/assets/songbird-hero.png";

export const BAND = {
  name: "Songbird",
  tagline: "Not to be missed — catch them if you can.",
  location: "Scotland",
  facebook: "https://www.facebook.com/groups/1687098342225934/",
  heroImg,
};

// Member tiles are cropped from the band's real promo photo (left → right).
// Names are placeholders — easy to edit here.
export const MEMBERS = [
  {
    id: "bass",
    name: "Band Member",
    role: "Bass",
    note: "Locking down the low end with decades of stagecraft.",
    pos: "8% 52%",
    zoom: 420,
  },
  {
    id: "guitar1",
    name: "Band Member",
    role: "Guitar",
    note: "Riffs, hooks and relentless energy.",
    pos: "31% 50%",
    zoom: 420,
  },
  {
    id: "vocals",
    name: "Songbird",
    role: "Lead Vocals",
    note: "The dynamic frontwoman — powerhouse vocals, total command of the stage.",
    pos: "50% 50%",
    zoom: 420,
    lead: true,
  },
  {
    id: "keys",
    name: "Band Member",
    role: "Keys",
    note: "The melodic backbone driving the pop & dance flavours.",
    pos: "70% 50%",
    zoom: 420,
  },
  {
    id: "guitar2",
    name: "Band Member",
    role: "Guitar",
    note: "Seasoned six-string showman with a feel for the big moment.",
    pos: "93% 52%",
    zoom: 420,
  },
];

// Honest placeholders — the band is \"pencilled in\" for festivals; exact dates TBC.
export const PLANS = [
  {
    id: "festivals",
    eyebrow: "Summer 2025",
    title: "Festival Season",
    body: "Pencilled in for several major festivals — bringing signature energy and dance-inducing sets to the crowds.",
    status: "Dates to be confirmed",
  },
  {
    id: "newmusic",
    eyebrow: "In the studio",
    title: "New Original Music",
    body: "Fresh, original material in the works — full of energy, powerful choruses and unforgettable hook lines.",
    status: "Coming soon",
  },
  {
    id: "tour",
    eyebrow: "2025",
    title: "The Extensive Tour",
    body: "Plans for a full tour, from intimate venues to grand stages the length and breadth of the country.",
    status: "Announcing soon",
  },
];

export const COVERS = [
  "Blondie",
  "Texas",
  "Iconic Female Artists",
  "Rock",
  "Alternative",
  "Pop",
  "Dance",
];

// Gallery moments — all framed from the band's real live photo.
export const GALLERY = [
  { id: "g1", label: "Centre stage", pos: "50% 30%", size: "170% auto", span: "lg:col-span-2 lg:row-span-2" },
  { id: "g2", label: "The frontwoman", pos: "50% 26%", size: "320% auto", span: "" },
  { id: "g3", label: "Low end", pos: "6% 34%", size: "300% auto", span: "" },
  { id: "g4", label: "Six strings", pos: "94% 34%", size: "300% auto", span: "" },
  { id: "g5", label: "The crowd", pos: "50% 92%", size: "190% auto", span: "" },
];
